/**
 * created by tian ruo jun
 Demo
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TreeModule from "./TreeModule";
import BaseComponent from "../../../base/BaseComponent";
import {Button, Icon, Input, Tree} from "antd";
import {ArrayDuplication,uuid} from '../../../utils'
import $ from 'jquery';
import {message} from '../../resource/components/Mess'
const getTree = "/cm-sites-sys/dept/getTree";
const getNode = "/cm-sites-sys/user/conditionQuery";

export default class CandidateComponents extends BaseComponent {
    static defaultProps = {
        deptId: '0'
    };
    static propTypes = {
        deptId: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {
            column:{
                key:'id',
                title:'name',
                children: 'child',
            },
            height: 630,
            width: 720,
            nodeWidth:190,
            nodeTextWidth:160,
            showRight: true,
            showLeftSearch: true,
            showRightSearch: true,
            nodeIcon:"folder-open",
            fileIcon:"file-text",
            nodeRightIcon:"star",
            searchTreeText:"",
            color: "#0050B3",
            // 树搜索
            searchParams: {
                "page": 0,  //当前页
                "size": 0,  //页容量
                "name": "", //账号或者姓名的模糊匹配字段
                "ifContainSonDept": 0,  //查询时是否包含子部门 1包含 0不包含 不包含就是只查这个部门，包含就是这个部门加它的子部门
                "deptIds": ['0'],  //部门id
                "ifSpecial":1, // 0查全部下所有部门，1把全部当普通部门（不查子部门）
            },
            parents:[],
            sons:[],
            treeData:[],
            checkedKeys:[],
            checkedNodes:[],
            selectList:[],
            expandedKeys:['0'],
            autoExpandParent:true,
            parentsNodeAll:[],//所有部门节点
            oldDeptIds:[],//已经查询过的部门
        }
    }

    componentWillMount() {
        // 获取所有父节点
        this.getParents();
        let department = [];
        department.push(this.props.deptId);
        this.state.searchParams.deptIds = department;
        this.state.color =  this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
        this.setState({}, () => {
            this.filterSearch(this.state.searchParams)
        })
    }

    componentDidMount() {
    }

    isWillUnmount = false;
    componentWillUnmount() {
        this.isWillUnmount = true;
    }

    getSelectList = (call) => {
        let selectList = this.state.selectList;
        call&&call(selectList)
    };

    setCheckedKeys = (checkedKeys=[]) => {
        let Ids = [];
        checkedKeys&&checkedKeys.length&&checkedKeys.forEach((item=>{
            let key = item.key&&item.key.split('-').at(-2);
            if(!key && item.deptList && item.deptList.length) {
                item.key = item.deptList[0].id + '-' + item.id;
            }
            Ids.push(item.id)
        }));
        this.setState({selectList:checkedKeys,checkedKeys:Ids})
    };
    



    // 获取所有父节点
    getParents = (id) => {
        if(this.props.deptId){
            this.state.expandedKeys = [this.props.deptId];
        }else{
            this.state.expandedKeys = ['0'];
        }
        this.setState({});
        this.request({
            url: getTree,
            body: {id: this.props.deptId ? this.props.deptId : 0},
            callBack: (res) => {
                let parents = [];
                if (res) {
                    parents = [res];
                }
                //只展示当前部门下面的人
                if (this.props.type === 'onlyThisDeptPerson') {
                    parents[0].child = []
                }

                // 给空部门加继子
                parents = this.addChild(parents);
                parents = this.addTag({type: 'dept'}, parents); // 为节点添加部门标记
                this.state.parents = parents;
                this.state.parentsNodeAll = [];
                this.getParentsNodeAll(parents, this.state.parentsNodeAll, "");
                this.reconstitutionTree();
            },
            errorCallBack: (e) => {
                this.setState({parents: []})
            }
        })
    };

    addChild = (parents) => {
        return parents.map(parent=>{
            if(parent.child && parent.child.length) {
                 return {
                     ...parent,
                     child: this.addChild(parent.child)
                 }
            } else {
                return {
                    ...parent,
                    child: [{
                        isStepson: true,
                        // 其他数据参照真数据，
                        id: uuid(),
                        fid: parent.id,
                        name: "stepson",
                    }]
                }
            }
        })
    };

    // 获取所有部门节点
    getParentsNodeAll = (parents, parentsNodeAll, key) => {
        if(!parents || parents.length<0) return;
        parents.forEach(item=>{
            if(!item.isStepson) {
                let newKey = "";
                if(key) {
                    newKey = key + "-" + item.id;
                } else {
                    newKey = item.id
                }
                parentsNodeAll.push(newKey);
                if(item && item.child) {
                    this.getParentsNodeAll(item.child, parentsNodeAll , newKey)
                }
            }
        })
    };

    // 过滤已经查过的节点
    filterSearch = (params, e,call) => {

        let newDeptIds = params.deptIds;
        if(!params.name) {

            newDeptIds = [];
            params&&params.deptIds&&params.deptIds.length&& params.deptIds.forEach(item=>{
                item = item.split('-').at(-1);
                if(this.state.oldDeptIds.indexOf(item)===-1) {
                    this.state.oldDeptIds.push(item);
                    newDeptIds.push(item);
                }else{
                    newDeptIds = params.deptIds;
                }
            });
        };
        if(newDeptIds.length<1) {
            call&&call([]);
            return false
        };

        params.deptIds = newDeptIds;

            this.getSons(params, call)


    };

    // 获取子节点
    getSons = (params, call) => {
        if(params.deptIds && params.deptIds.length) {
            params.deptIds = params.deptIds.map(deptId=>(deptId.split('-').at(-1)))
        };
        this.request({
            url: getNode,
            body: params,
            method: 'post',
            contentType: 'json',
            callBack: (res) => {
                let sons = [];
                if (res) {
                    sons = res.data;

                }
                if (call) {
                    call(sons);
                    // return
                }
                sons = this.addTag({type: 'person'}, sons); // 为节点添加人员标记
                this.state.sons =sons;
                this.reconstitutionTree();
            },
            errorCallBack: (e) => {
                if (call) {
                    return
                }
                this.setState({sons: []})
            }
        });
        this.setState({})
    };

    render() {
        return (
            <TreeModule
                {...this.state}
                onExpand={this.onExpand}
                onCheck={this.onCheck}
                onSelect={this.onSelect}
                onRemove={this.onRemove}
                onSearchSelect={this.onSearchSelect}
                onSearchTree={this.onSearchTree}
                onRemoveAll={this.onRemoveAll}
                checkedKeys={this.state.checkedKeys}
            />
        )
    }

    // 重组树结构
    reconstitutionTree = () => {
        let {parents, sons, treeData} = this.state;
        let newTreeData = treeData && treeData.length ? JSON.parse(JSON.stringify(treeData)) :JSON.parse(JSON.stringify(parents));
        try {
            console.log("开始寻亲",Date.now());
            newTreeData = this.recursionFun(newTreeData, sons);
            console.log("寻亲结束",Date.now())
        } catch (e) {
            newTreeData = [];
        }

        if(this.isWillUnmount){
            return;
        }
        window.loading.show(true);
        this.state.treeData = newTreeData;
         setTimeout(()=>{
            this.setState({treeData:newTreeData},()=>{
                $(' #treeBox .ant-motion-collapse-enter').css('height','auto')
                window.loading.hide();
            })
        });
     };

    

    // 为节点添加标记
    addTag = (tag,data) => {
        if(!data || data.length<1) return data;
        return  data.map(item=>{
            if(item.child && item.child.length>0) {
                item.child = this.addTag(tag,item.child)
            }
            return {...item,...tag}

        })

    };

    // 寻亲函数
    recursionFun = (parents, sons) => {
        if(!parents || parents.length<1) return parents; // child: []  id: "6264da567c68076807915c470"
        if(!sons || sons.length<1) return parents; // deptIds: ["0"]
        return parents.map(parent=>{
            if(parent.child) {
                let parentId = parent.id;
                let mySons = sons.filter(son=>son.deptIds.includes(parentId)); // 一个人可以有多个部门
                if(mySons && mySons.length) {
                    mySons = mySons.filter(mySon=>!parent.child.some(item=>item.id==mySon.id));
                    parent.child.push(...mySons);
                    // 过滤继子
                    parent.child = parent.child.filter(mySon=>!mySon.isStepson);
                    // mySons.forEach(mySon=>{
                    //     if(parent.child.every(item=>item.id!==mySon.id)) {
                    //         parent.child.push(mySon);
                    //     }
                    // })
                }
                if(parent.child.length>0){
                    this.recursionFun(parent.child, sons)
                }
            }
            return parent
        })
    };

    // 将左侧选中的人放到右边
    onSelect = () => {

        let {searchTreeText, checkedKeys,checkedNodes}=this.state;

        //筛选出选中的人
        if(checkedKeys&&checkedKeys.length<1){
            return message.error('请先选择部门或者人员！')
        }
        let selectList=[];
        let oldSelectList = this.state.selectList;
        if(searchTreeText){
           
            // 如果是搜索后的数据，应该只选中当前选中的人，此时页面已经存在数据，不需要再重新搜索
            let newSelectList=[];
            let oldSons = this.state.sons; // 通过搜索搜到的人
            // newArr = oldSons.filter(item=>checkedKeys.includes(item.id));
            // 从选中的节点中筛选出人
            newSelectList = this.state.checkedNodes.filter(item=>item.type==="person");
            // 从选中的人中筛选出符合搜索条件的
            newSelectList = newSelectList.filter(item=>item.name.indexOf(searchTreeText)>-1);
            // 将
            selectList=[...oldSelectList,...newSelectList];
            selectList = this.deWeight(selectList);
            this.setState({selectList});
        } else {

            // 如果没有使用搜索功能，则应该默认选中所选部门下所有人
            let deptList = this.state.checkedNodes.filter(item=>item.type=='dept' && checkedKeys.includes(item.key));
            // let deptListId= deptList&&deptList.length>0?deptList.map(item=>item.id):null;
            let deptListId=[]
            deptList&&deptList.length&&deptList.map((item,index)=>{
                if(!item.isStepson){
                     deptListId.push(item.id)
                }

            })
            if(deptListId&&deptListId.length) {

                deptListId.forEach(deptId=>{
                    // 选中的里面有部门
                    let params = {
                        "page": 0,  //当前页
                        "size": 0,  //页容量
                        "name": "", //账号或者姓名的模糊匹配字段
                        "ifContainSonDept": 0,  //查询时是否包含子部门 1包含 0不包含 不包含就是只查这个部门，包含就是这个部门加它的子部门
                        "deptIds": [deptId]  //部门id
                    };
                    this.filterSearch(params,'',(sons)=>{

                        if(sons&&sons.length){
                            sons.forEach(item=>{
                                item.key = deptId+ "-" +item.id
                            })
                        }
                        //调递归方法，便利选中的部门，判断选中的部门下面是否有人，如果没人把这个部门存起来，提示
                        // this.filterSelectDept
                        // this.checkDeptHasParen(deptList);
                        selectList = sons;
                        this.checkDeptHasParen(deptList);
                        // 这里应该把当前选中的单个人也加上
                        let checkedSons = this.state.checkedNodes.filter(item=>item.type=='person');

                    
                        selectList=[...this.state.selectList,...selectList,...checkedSons];
                        selectList = this.deWeight(selectList);
                        this.setState({selectList},()=>{
                            let deptListNode = this.state.checkedNodes.filter(item=>item.type=='dept' && checkedKeys.includes(item.key))
                        });
                    });
                });
            } else {
                // 没有选中部门
                let checkedSons = this.state.checkedNodes.filter(item=>item.type=='person');
                selectList=[...oldSelectList,...checkedSons];
                selectList= this.deWeight(selectList);
                this.setState({selectList});
                // message.error('')
            }

        }
    };

    // 校验空部门
    checkDeptHasParen = (deptList) => {
        let emptDept = [];
        try {
            emptDept = this.checkDept(emptDept,deptList)
        } catch (e) {
            emptDept = []
        }
        if(emptDept&&emptDept.length) {
            message.info("123")
        }
    };
    // 校验空部门
    checkDept = (emptDept,deptList) => {
          if(deptList&&deptList.length) {

          }
    };

    // //过滤部门以假数据
    // filterSelectDept =(checkedNodes,selectList)=>{
    //     let newArray =[]
    //     //将选中的人放在这里面
    //     selectList&&selectList.length&&selectList.forEach((item,index)=>{
    //        if(item.deptList&&item.deptList.length){
    //            item.deptList.forEach((I,Ids)=>{
    //                if(checkedNodes.indexOf(I)=== -1){
    //                    newArray.push(I)
    //                }
    //            })
    //        }
    //
    //     })
    //     newArray&&newArray.length&&newArray.forEach((item=>{
    //         if(item.id)
    //     }))
    // };



    // 数组去重
    deWeight = (selectList) => {
        let newList = [];
       
        selectList.forEach(item=>{

            if(!item.key) {
                item.key = item.id
            }
            if(!newList.some(item2=>item2.key===item.key)){
                newList.push(item)
            }
        });
        return newList
    };

    onRemove = (son) => {
        // console.log(this.state.selectList,'this.state.selectList')
        this.state.selectList = this.state.selectList.filter(item=>item.key!==son.key);
        this.setState({});
    };

    onRemoveAll = () => {
        
        this.state.selectList = [];
        this.setState({});
          
      
    };

    onExpand = (expandedKeys,e) => {
         if(expandedKeys.length<1) return;
        const {parents}=this.state;
        this.state.searchParams.deptIds=expandedKeys;
        this.state.expandedKeys=expandedKeys;
        this.state.autoExpandParent=false;
        if(e.expanded){
            this.filterSearch(this.state.searchParams,e,()=>{
                window.loading.show(true);
                setTimeout(()=>{
                    this.setState({},()=>{
                        window.loading.hide();
                    })
                });
            })
        }else{
            this.setState({})
        }


    };
    // 右侧搜人
    onSearchSelect = (val) => {
        let {selectList} = this.state;
        selectList.forEach(item => {
            item.hide = val && !item.name.includes(val)
        });
        this.setState({selectList})
    }
    // 左侧搜人
    onSearchTree = (val) => {
        this.state.searchParams.name=val;
        this.state.searchTreeText=val;
        this.state.checkedKeys=[];
        this.state.checkedNodes=[];
        if(val){
            this.state.expandedKeys = this.state.parentsNodeAll;
            this.state.searchParams.deptIds=this.state.parentsNodeAll;
            this.filterSearch(this.state.searchParams);
        } else {
           
            this.state.expandedKeys = this.props.deptId ? [this.props.deptId] : ['0'];
            this.state.searchParams.deptIds= this.props.deptId ? [this.props.deptId] : ['0'];
            this.setState({});
             
        }
    };

    onCheck = (checkedKeys, info) => {

        let nodes = info.checkedNodes;
        // let node = nodes[0].props.dataRef; // 当前选中的节点完整数据
        this.state.checkedKeys=checkedKeys;
        this.state.checkedNodes=nodes.map(item=>item.props.dataRef);
        this.setState({});


        // if(this.state.checkedNodes&&this.state.checkedNodes.length){
        //     let checkedDept= this.state.checkedNodes.filter(item=>item.type==='dept');
        //     if(checkedDept&&checkedDept.length){
        //         this.state.searchParams.deptIds=checkedDept.map(item=>item.key);
        //         this.filterSearch(this.state.searchParams,(sons)=>{
        //             console.log("sons===========",sons)
        //             // this.state.checkedKeys = [...this.state.checkedKeys,]
        //             window.loading.show(true);
        //             setTimeout(()=>{
        //                 this.setState({},()=>{
        //                     window.loading.hide();
        //                 })
        //             });
        //         })
        //     }
        // }
    };


}